import {
  ArrowRight,
  Armchair,
  Book,
  Camera,
  Car,
  Cpu,
  Dumbbell,
  Footprints,
  Gamepad2,
  Headphones,
  Home,
  Laptop,
  PawPrint,
  PenTool,
  Puzzle,
  Shirt,
  ShoppingBasket,
  Smartphone,
  Sparkles,
  Tv,
  WashingMachine,
  Watch
} from "lucide-react";
import Link from "next/link";

const categoryIcons = {
  "Mobiles & Accessories": Smartphone,
  "Laptops & Computers": Laptop,
  Electronics: Cpu,
  "Headphones & Audio": Headphones,
  TVs: Tv,
  Cameras: Camera,
  Watches: Watch,
  "Men's Fashion": Shirt,
  "Women's Fashion": Shirt,
  Shoes: Footprints,
  "Home & Kitchen": Home,
  Furniture: Armchair,
  "Beauty & Personal Care": Sparkles,
  Grocery: ShoppingBasket,
  "Sports & Fitness": Dumbbell,
  Books: Book,
  "Toys & Games": Puzzle,
  Gaming: Gamepad2,
  "Office & Stationery": PenTool,
  Appliances: WashingMachine,
  Automotive: Car,
  "Pet Supplies": PawPrint
};

const excludedCategories = new Set([
  "Home & Kitchen",
  "Furniture",
  "Beauty & Personal Care",
  "Grocery",
  "Sports & Fitness",
  "Books",
  "Toys & Games",
  "Gaming",
  "Office & Stationery",
  "Appliances",
  "Automotive",
  "Pet Supplies"
]);

export function CategoryTiles({ categories }: { categories: string[] }) {
  const visibleCategories = categories.filter((cat) => !excludedCategories.has(cat));

  return (
    <section>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {visibleCategories.map((category) => {
          const Icon = categoryIcons[category as keyof typeof categoryIcons] ?? Sparkles;

          return (
            <Link
              key={category}
              href={`/search?category=${encodeURIComponent(category)}`}
              className="group flex flex-col justify-between gap-3 sm:gap-5 rounded-2xl border border-slate-200/90 bg-white p-3.5 sm:p-4 shadow-2xs transition duration-200 hover:border-[#00B7B0] hover:shadow-md dark:border-white/10 dark:bg-slate-900"
            >
              <div className="flex items-center justify-between gap-2">
                <h3 className="text-xs sm:text-[14px] font-bold leading-tight text-[#073B70] dark:text-white group-hover:text-[#087DB5] transition-colors">{category}</h3>
                <Icon className="h-6 w-6 sm:h-7 sm:w-7 shrink-0 text-[#00B7B0] transition-transform duration-200 group-hover:scale-110" />
              </div>
              <span className="inline-flex items-center gap-1 text-xs sm:text-sm font-bold text-[#087DB5] group-hover:text-[#00B7B0] group-hover:underline transition-colors">
                See more
                <ArrowRight className="h-3.5 w-3.5" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
